/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Seo_Items_TitleInputs */

const he_seo_items_title = /** @type {(inputs: Seo_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`מוצרי KSP - השוואת מחירים | Pricedrop`)
};

const en_seo_items_title = /** @type {(inputs: Seo_Items_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`KSP Products - Price Comparison | Pricedrop`)
};

/**
* | output |
* | --- |
* | "KSP Products - Price Comparison \| Pricedrop" |
*
* @param {Seo_Items_TitleInputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
export const seo_items_title = /** @type {((inputs?: Seo_Items_TitleInputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Seo_Items_TitleInputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_seo_items_title(inputs)
	return en_seo_items_title(inputs)
});